import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  name: '',
  products: []
};

let store = set => ({
  ...initialState,
  updateName: name => {
    set(() => ({
      name
    }));
  },
  updateProducts: products => {
    set(() => ({
      products
    }));
  },
  reset: () => set(initialState)
});

store = persist(store, {
  name: 'newCollection',
  storage: createJSONStorage(() => sessionStorage)
});
export const useNewCollectionStore = create(devtools(store));
